import { useState } from 'react';

import type {
  RewardPool} from '@shared/api/types/rewardPools';
import {
  REWARD_POOL_DISTRIBUTION_POLICY,
  REWARD_POOL_STATUS
} from '@shared/api/types/rewardPools';

import { EntryOptionsDialog } from './dialogs/EntryOptionsDialog';
import { RequirementsDialog } from './dialogs/RequirementsDialog';

type Props = {
  rewardPool: RewardPool;
};

export const RewardPoolOptionsButton = ({ rewardPool }: Props) => {
  const [isOpenRequirements, setIsOpenRequirements] = useState(false);
  const [isOpenEntryOptions, setIsOpenEntryOptions] = useState(false);

  const handleRequirementsButtonClick = () => {
    if (rewardPool.distribution_policy === REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2) {
      setIsOpenEntryOptions(true);
    } else {
      setIsOpenRequirements(true);
    }
  };

  return (
    <>
      <RequirementsDialog
        rewardPool={rewardPool}
        onOpenChange={setIsOpenRequirements}
        open={isOpenRequirements}
      />

      <EntryOptionsDialog
        rewardPool={rewardPool}
        onOpenChange={setIsOpenEntryOptions}
        open={isOpenEntryOptions}
      />

      <button
        onClick={handleRequirementsButtonClick}
        disabled={
          rewardPool.status !== REWARD_POOL_STATUS.ACTIVE &&
          rewardPool.status !== REWARD_POOL_STATUS.PENDING
        }
        className="msq-btn msq-btn-lg msq-btn-secondary flex-1 whitespace-nowrap"
        data-qa="requirements_button"
      >
        {rewardPool.distribution_policy === REWARD_POOL_DISTRIBUTION_POLICY.RAFFLE_V2
          ? 'Entry Options'
          : 'Requirements'}
      </button>
    </>
  );
};
